export default function BackCommand() {
    if(window.parent) {
        try {
            return window.parent.history.back()
        } catch(e) {
        
        }
        window.history.back()
    } else {
        window.history.back()
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/betbar/back-command.ts